import { TextLink, TextLinkButton } from 'braid-design-system';
import React from 'react';
import { useNavigate } from 'react-router';

export const TextLinkComponent = ({
  isInternalRoute,
  textId,
  linkPath,
  linkMessage,
}: {
  isInternalRoute: boolean;
  textId: string;
  linkPath: string;
  linkMessage: string;
}) => {
  const navigate = useNavigate();
  return isInternalRoute ? (
    <TextLinkButton
      data={{ testid: textId }}
      onClick={() => navigate(linkPath)}
    >
      {linkMessage}
    </TextLinkButton>
  ) : (
    <TextLink data={{ testid: textId }} href={linkPath}>
      {linkMessage}
    </TextLink>
  );
};
